import {
  jb_overlay_css_default
} from "./chunk.SAOT3ODZ.js";
import {
  se
} from "./chunk.PMWHHJSU.js";
import {
  createFocusTrap
} from "./chunk.PZQJ2H5Y.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  Stackable
} from "./chunk.YYW5LEED.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  o,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-overlay/jb-overlay.ts
var JbOverlay = class extends Initiable(Stackable(r)) {
  constructor() {
    super(...arguments);
    this.ARILABELS_DEFAULT = {
      close: "Close"
    };
    this.fullHeight = false;
    this.hasCloseIcon = true;
    this.newAnimation = false;
  }
  firstUpdated() {
    if (this._introPromiseResolve) {
      window.setTimeout(() => {
        this._section.classList.add("visible");
        this._section.addEventListener("transitionend", (event) => {
          if (event.propertyName === "height") {
            this._introPromiseResolve(true);
          }
        });
        const tabbableOverlayChild = this._assignedElements[0]?.shadowRoot.children[0];
        const nav = document.querySelector("jb-navigation");
        const navCloseButton = nav.shadowRoot.querySelector(".burger-button");
        const overlayControls = this.renderRoot.querySelector(".overlay__close-btn");
        const overlayContainer = this.renderRoot.querySelector(".overlay__container");
        const focusTrappedElements = [];
        const focusTrapOptions = {
          clickOutsideDeactivates: true,
          escapeDeactivates: true,
          onPostActivate: () => {
            document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          },
          tabbableOptions: {
            getShadowRoot: true
          },
          setReturnFocus: this.returnFocusTo
        };
        if (this.usesOriginalControls()) {
          focusTrappedElements.push(tabbableOverlayChild);
          focusTrappedElements.push(overlayControls);
          focusTrapOptions.onPostActivate = () => {
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
            }, 350);
          };
        } else {
          focusTrappedElements.push(overlayContainer);
          focusTrappedElements.push(nav);
          focusTrapOptions.initialFocus = navCloseButton;
        }
        this._focusTrapInstance = createFocusTrap(focusTrappedElements, focusTrapOptions);
        this._focusTrapInstance.activate();
        document.querySelector("jb-bypass-block")?.style.setProperty(
          "--_display-bypass-block",
          "none"
        );
      }, 10);
    }
  }
  async intro() {
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 350);
    return new Promise((resolve) => {
      this._introPromiseResolve = resolve;
    });
  }
  async outro() {
    return new Promise((resolve) => {
      if (!this.newAnimation) {
        this._section.classList.remove("visible");
      } else {
        resolve(true);
      }
      this._section.addEventListener("transitionend", (event) => {
        if (event.propertyName === "height") {
          resolve(true);
        }
      });
      this._focusTrapInstance.deactivate();
      document.querySelector("jb-bypass-block")?.style.setProperty("--_display-bypass-block", "block");
      setTimeout(() => {
        this.returnFocusTo?.focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      }, 100);
    });
  }
  stacked() {
  }
  unstacked() {
    this.returnFocusTo?.focus();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 350);
    this.remove();
  }
  usesOriginalControls() {
    const componentsWithOriginalControls = [
      "JB-CONTACT-OVERLAY",
      "JB-NEWS-OVERLAY",
      "JB-GALLERY-FULLSCREEN",
      "JB-PUBLICATION-DOWNLOAD-OVERLAY",
      "JB-MEDIA-OVERLAY"
    ];
    let currentElement = this._assignedElements[0];
    let hasOverlayWithOriginalControls = false;
    while (currentElement?.shadowRoot) {
      const nextElement = currentElement.shadowRoot.children[0];
      if (componentsWithOriginalControls.includes(currentElement.tagName)) {
        hasOverlayWithOriginalControls = true;
        break;
      }
      if (nextElement?.shadowRoot?.querySelector(".jb-overlay")) {
        hasOverlayWithOriginalControls = true;
        break;
      }
      currentElement.childNodes?.forEach((node) => {
        if (componentsWithOriginalControls.includes(node.tagName)) {
          hasOverlayWithOriginalControls = true;
        }
      });
      currentElement = nextElement;
    }
    return hasOverlayWithOriginalControls;
  }
  _close() {
    this.dispatchEvent(
      new CustomEvent("jb-overlay:close", {
        bubbles: true,
        composed: true
      })
    );
  }
  get _slottedChildren() {
    const slot = this.shadowRoot.querySelector("slot");
    return slot.assignedElements();
  }
  render() {
    return ke`
      <section
        aria-label="${this.ariaLabels?.label ?? D}"
        aria-modal="true"
        role="dialog"
        class=${Rt({
      overlay: true,
      "overlay--gray": this.color === "gray",
      "overlay--blue": this.color === "blue",
      "new-animation": !!this.newAnimation,
      fullheight: !!this.fullHeight,
      visible: true
    })}
        style=${se({ zIndex: this.zIndex().toString() })}
      >
        <div class="overlay__container">
          <div class="overlay__header">
            <div class="${Rt({ "overlay__logo-wrap": true, "no-logo": !this.hasLogo })}">
              <jb-logo
                .href=${this.logoLink}
                .svgLogo=${this.svgLogo}
              ></jb-logo>
            </div>
            <div
              class="overlay__close-btn"
              data-fly-catcher
            >
              ${this.hasCloseIcon ? ke`<button
                    aria-label="${this.ariaLabels?.close ?? this.ARILABELS_DEFAULT.close}"
                    @click=${this._close}
                    @keydown=${(event) => {
      if (event.code === "Enter" || event.code === "Space") {
        this._close();
      }
    }}
                  >
                    <jb-close-icon></jb-close-icon>
                  </button>` : D}
            </div>
          </div>
          <div class="${Rt({ overlay__content: true, relative: !!this.relativeContent })}">
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
};
JbOverlay.styles = [reset_css_default, jb_overlay_css_default];
JbOverlay.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbOverlay.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbOverlay.prototype, "color", 2);
__decorateClass([
  n({ type: Boolean })
], JbOverlay.prototype, "fullHeight", 2);
__decorateClass([
  n({ type: Boolean })
], JbOverlay.prototype, "hasCloseIcon", 2);
__decorateClass([
  n({ type: Boolean })
], JbOverlay.prototype, "hasLogo", 2);
__decorateClass([
  n()
], JbOverlay.prototype, "logoLink", 2);
__decorateClass([
  n({ type: Boolean })
], JbOverlay.prototype, "newAnimation", 2);
__decorateClass([
  n({ type: Boolean })
], JbOverlay.prototype, "relativeContent", 2);
__decorateClass([
  n({ type: Object })
], JbOverlay.prototype, "returnFocusTo", 2);
__decorateClass([
  n()
], JbOverlay.prototype, "svgLogo", 2);
__decorateClass([
  o()
], JbOverlay.prototype, "_assignedElements", 2);
__decorateClass([
  r2()
], JbOverlay.prototype, "_focusTrapInstance", 2);
__decorateClass([
  e("section")
], JbOverlay.prototype, "_section", 2);
JbOverlay = __decorateClass([
  customElement("jb-overlay")
], JbOverlay);

export {
  JbOverlay
};
